import * as React from 'react';
import {useEffect, useState} from 'react';
import {RouteComponentProps} from "react-router";
import Utils from "../../Utils";
import InstanceGridEditor from "../../components/bo-core/InstanceGridEditor";
import InstanceLayoutEditor from "../../components/bo-core/instanceLayoutEditor/InstanceLayoutEditor";
import {setBusinessObject} from "../../actions/manageDataBusinessObjectActions";
import {connect} from "react-redux";

export enum SLIDE {
    GRID_EDITOR = "GRID_EDITOR",
    LAYOUT_EDITOR = "LAYOUT_EDITOR"
}
const Accordeon = (props: any) => {
    const [slide, setSlide] = useState<SLIDE>(SLIDE.GRID_EDITOR);

    useEffect(() => {
        localStorage.setItem('cameFromInstance', 'cameFromInstance');
        Utils.$('#accordeon').liteAccordion({
            responsive: true,
            minContainerWidth: 800,
            containerWidthOffset: 270,
            containerHeightOffset: 70,
            theme: "dark",
            rounded: false,
            enumerateSlides: true,
            synchronousResize: true,

            onSlideAnimComplete: () => {

            },
            onBeforeTriggerSlide: (args) => {
                if (Utils.$(args).prop("id") == "gridEditor") {
                    setSlide(SLIDE.GRID_EDITOR);
                } else if (Utils.$(args).prop("id") == "layoutEditor") {
                    setSlide(SLIDE.LAYOUT_EDITOR);
                }
                return true;
            },
            onTriggerSlide: () => {

            }
        });
        $("#hide-nav-btn").on("click", function () {
            const core = $("#accordeon").data("coreInstance");
            if (!$(document.body).hasClass("mini-navbar")) {
                core.setSlideWidth(window.innerWidth - 120);
            } else {
                core.setSlideWidth(window.innerWidth - 270);
            }
        });

        return () => {
            $("#hide-nav-btn").off();
        }
    }, []);

    return (
        <div id={"instanceEdit"} style={{height: "100%"}} className={"container-fluid"} tabIndex={-1}>
            <div id="accordeon">
                <ol>
                    <li>
                        <h2 id={"gridEditor"}><span style={{fontSize: 15}}>Edit</span></h2>
                        <div>
                            { slide === SLIDE.GRID_EDITOR ? <InstanceGridEditor
                                setBusinessObject={props.setBusinessObject}
                                slide={slide}
                                match={props.match}
                                history={props.history}
                                location={props.location}
                            /> : null}
                        </div>
                    </li>

                    <li>
                        <h2 id={"layoutEditor"}><span style={{fontSize: 15}}>Data Navigator</span></h2>
                        <div>
                            { slide === SLIDE.LAYOUT_EDITOR ? <InstanceLayoutEditor
                                slide={slide}
                                match={props.match}
                                history={props.history}
                                location={props.location}
                            /> : null}
                        </div>
                    </li>
                </ol>
            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        setBusinessObject: (obj) => {
            dispatch(setBusinessObject(obj))
        }
    }
};

export default connect(null, mapDispatchToProps)(Accordeon)



// WEBPACK FOOTER //
// ./app/views/bo-core/Accordeon.tsx